export function setCachepieseschimbLoading (state, loading = false) {
  state.cachepieseschimbLoading = loading
}

export function setCachepieseschimb (state, cachepieseschimb) {
  if (cachepieseschimb && cachepieseschimb.data) {
    state.cachepieseschimb = cachepieseschimb.data
    state.cachepieseschimbCurrentPage = cachepieseschimb.current_page
    state.cachepieseschimbLastPage = cachepieseschimb.last_page
    state.cachepieseschimbPerPage = cachepieseschimb.per_page
    state.cachepieseschimbTotal = cachepieseschimb.total
  } else if (cachepieseschimb && Array.isArray(cachepieseschimb)) {
    state.cachepieseschimb = cachepieseschimb
    state.cachepieseschimbCurrentPage = 1
    state.cachepieseschimbLastPage = 1
    state.cachepieseschimbPerPage = 100
    state.cachepieseschimbTotal = cachepieseschimb.length
  }
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
